<template>
    <div class="form-check row" v-if="bootstrap4">
        <div class="form-group">
            <div class="form-check">
                <input
                    :checked="value"
                    class="form-check-input"
                    :class="{'is-invalid': isInvalid}"
                    id="terms_and_conditions"
                    @input="e => $emit('input', e.target.checked)"
                    name="terms_and_conditions"
                    required
                    type="checkbox"
                >
                <label for="terms_and_conditions" class="form-check-label">I accept the <a href="#" data-toggle="modal" data-target="#termsModal">terms and conditions</a></label>
                <div class="invalid-feedback">You must accept the terms and conditions in order to proceed.</div>
            </div>
        </div>
    </div>
    <div v-else>
        <small>By signing up, you agree to our terms and conditions</small>
        <div class="form-group">
            <input
                :checked="value"
                id="terms_and_conditions"
                @input="e => $emit('input', e.target.checked)"
                name="terms_and_conditions"
                required
                type="checkbox"
            >
            <label for="terms_and_conditions">I accept the <a href="#" data-toggle="modal" data-target="#termsModal">terms and conditions</a></label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TermsConditions',

    props: {
        isInvalid: {
            default: false,
            required: false,
            type: Boolean,
        },
        bootstrap4: {
            required: true,
            type: Boolean,
        },
        value: {
            required: true,
            type: Boolean,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/Inputs/TermsConditions.vue